<template>
	<div class="category">
		<el-row>
			<el-col style="width: 140px; margin-left: 40px;">
				<el-input v-model="query.uid" placeholder="请输入用户UID"></el-input>
			</el-col>
			<el-col style="width: 140px; margin-left: 40px;">
				<el-input v-model="query.ip" placeholder="请输入IP"></el-input>
			</el-col>
			<el-col style="width: 50px; margin-left: 120px;">
				<el-button class="pull-right" type="primary" @click="handleSearch">搜索</el-button>
			</el-col>
		</el-row>
		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column prop="user_id" label="用户Uid"></el-table-column>
				<el-table-column prop="ip" label="Ip"></el-table-column>
				<el-table-column prop="created_at" label="登录时间"></el-table-column>
			</el-table>
			<el-pagination
				background
				:total="dataMeta ? dataMeta.total : 0"
				:current-page="dataMeta ? dataMeta.current_page : 1"
				:page-size="dataMeta ? dataMeta.per_page : 15"
				@current-change="handlePageChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import { getApiData } from '../../http'
export default {
	data() {
		return {
			loading: false,
			dataList: undefined,
			dataMeta: {},
			query: {
				page: 1,
				uid: undefined,
				ip: undefined
			}
		}
	},
	methods: {
		getData() {
			this.loading = true
			getApiData(`user_login_ips`, { page: this.query.page, uid: this.query.uid, ip: this.query.ip })
				.then(res => {
					this.dataList = res.data
					this.dataMeta = {
						current_page: res.current_page,
						per_page: res.per_page,
						total: res.total
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
		handleSearch() {
			this.query.page = 1
			this.getData()
		},
		handlePageChange(page) {
			this.query.page = page
			this.getData()
		}
	},
	created() {
		this.getData()
	}
}
</script>

<style lang="less">
.table-image {
	max-height: 100px;
	max-width: 100px;
}

.avatar-uploader {
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.el-upload:hover {
		border-color: #409eff;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
	overflow: auto;
	/* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
	display: none;
}


.abow_dialog {
	display: flex;
	justify-content: center;
	align-items: Center;
	overflow: hidden;

	.el-dialog {
		margin: 0 auto !important;
		height: 90%;
		overflow: hidden;

		.el-dialog__body {
			position: absolute;
			left: 0;
			top: 54px;
			bottom: 0;
			right: 0;
			padding: 0;
			z-index: 1;
			overflow: hidden;
			overflow-y: auto;
		}
	}
}
</style>
